import { Typography } from '@mui/material';

const NOTE_SX = {
  lineHeight: 1.45,
} as const;

const CallbackAvailabilityNote = () => (
  <Typography variant="body2" color="secondary" sx={NOTE_SX}>
    You should be available in the next 10 minutes for an immediate callback.
  </Typography>
);

export default CallbackAvailabilityNote;
